import { render } from "./EditModal.vue?vue&type=template&id=74289b72&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=74289b72&scoped=true&lang=css"
import "./EditModal.vue?vue&type=style&index=1&id=74289b72&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74289b72"]])

export default __exports__